module.exports = {"loading":"Cargando, favor espera..."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/es.json
// module id = ./src/locale/es.json
// module chunks = 0